import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
export async function getReturnableItems(params) {
  const p = {};
  Object.entries(params).forEach(([k, v]) => { if (v !== '' && v !== undefined && v !== null) p[k] = v; });
  const r = await axios.get(`${API}/brand-ops/returnable-items`, { headers: h(), params: p });
  return r.data;
}
export async function confirmBrandReturn(brand_name, item_ids) {
  const r = await axios.post(`${API}/brand-ops/confirm-return`, { brand_name, item_ids }, { headers: h() });
  return r.data;
}
export async function getReturnsLog() {
  const r = await axios.get(`${API}/brand-ops/returns-log`, { headers: h() });
  return r.data;
}
export async function getReturnReport(brand_return_id) {
  const r = await axios.get(`${API}/brand-ops/returns-log/${brand_return_id}/report`, { headers: h() });
  return r.data;
}
